import { useState, useRef, useEffect } from 'react';
import { Send, Loader2 } from 'lucide-react';
import AgentPicker from './AgentPicker';

const ChatInput = ({ onSend, disabled, placeholder, selectedAgent, onAgentChange }) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 140) + 'px';
    }
  }, [message]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (message.trim() && !disabled) {
      onSend(message.trim());
      setMessage('');
    }
  };

  return (
    <div
      className="bg-white border border-[#E2E8F0] rounded-xl"
      style={{ boxShadow: '0 2px 4px -2px rgba(0,0,0,0.05)' }}
      data-testid="chat-input-container"
    >
      <textarea
        ref={textareaRef}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder={placeholder || 'Describe your app idea...'}
        disabled={disabled}
        rows={1}
        data-testid="chat-input-textarea"
        className="w-full bg-transparent text-sm text-[#0F172A] placeholder:text-[#94A3B8] resize-none outline-none px-4 pt-3 pb-1 min-h-[40px] max-h-[140px]"
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
          }
        }}
      />

      <div className="flex items-center justify-between px-3 pb-2.5 pt-1">
        <AgentPicker value={selectedAgent} onChange={onAgentChange} />

        <button
          onClick={handleSubmit}
          disabled={disabled || !message.trim()}
          data-testid="chat-send-button"
          className="w-7 h-7 rounded-lg bg-[#2563EB] hover:bg-[#1D4ED8] disabled:bg-[#E2E8F0] disabled:cursor-not-allowed flex items-center justify-center transition-colors"
        >
          {disabled ? (
            <Loader2 className="w-3.5 h-3.5 text-[#94A3B8] animate-spin" />
          ) : (
            <Send className="w-3.5 h-3.5 text-white" />
          )}
        </button>
      </div>
    </div>
  );
};

export default ChatInput;
